module.exports = __webpack_public_path__ + "img/EN ISO 374.5af203a3.png";